var VZThirdParty = VZThirdParty || {};

///////////////////////////////////////////
////
////       Verizon Third Party JS APIs
////
///////////////////////////////////////////

var VZThirdParty = (function () {
	var EventId = {
		CHANNEL_TUNE: 'CHANNEL_TUNE',
		CHANNEL_RECORD: 'CHANNEL_RECORD',
		CHANNEL_REMINDER: 'CHANNEL_REMINDER',
		ONDEMAND_LAUNCH: 'ONDEMAND_LAUNCH',
		ONDEMAND_TLM: 'ONDEMAND_TLM',
		ONDEMAND_RAIL: 'ONDEMAND_RAIL',
		ONDEMAND_CONTENT: 'ONDEMAND_CONTENT',
		ONDEMAND_PI: 'ONDEMAND_PI',
		LIVETV_PI: 'LIVETV_PI',
		VOD_PI: 'VOD_PI',
		DVR_PI: 'DVR_PI',
		APPS_LAUNCH: 'APPS_LAUNCH',
		PERFORM_ACTION: 'PERFORM_ACTION',
		REQUEST_INFO: 'REQUEST_INFO',
	};

	var event_cb_map = [];
	var TransactionID = 6000;

	function __addEventListener(id, callback) {
		try {
			event_cb_map[id] = callback;
		} catch (ex) {
			console.error('Exception in VZThirdParty.__addEventListener() ' + ex);
		}
	}

	function __removeEventListener(id) {
		try {
			delete event_cb_map[id];
		} catch (ex) {
			console.error('exception in VZThirdParty.__removeEventListener() ' + ex);
		}
	}

	function __ExecuteCommandAsync(input, callback) {
		var json_input = input || {};
		TransactionID++;
		json_input['transactionid'] = TransactionID;
		if (callback) {
			__addEventListener(TransactionID, callback);
		}
		__VZThirdParty.ExecuteCommand(JSON.stringify(json_input));
	}

	function __EventHandler(id, data) {
		var response = {};
		try {
			if (typeof data == 'string') response = JSON.parse(data);
			else if (typeof data == 'object') response = data;
		} catch (ex) {
			console.error('VZThirdParty.__EventHandler Unable to parse the response data ' + data);
			return;
		}

		var EventId = response.transactionid;
		console.log(
			'VZThirdParty.__EventHandler() id ' +
				id +
				' EventId: ' +
				EventId +
				', Data: ' +
				response,
		);
		if (response.transactionid) delete response.transactionid;
		if (event_cb_map[EventId]) {
			event_cb_map[EventId](response);
			__removeEventListener(EventId);
		}
	}

	return {
		Init: function () {
			console.log('VZThirdParty.Init');
			if (!__VZThirdParty) {
				console.error(
					'VZThirdParty undefined... Error in loading libvzthirdparty-plugin.so',
				);
				return;
			}
			__VZThirdParty.addEventListener(__VZThirdParty.RETURN_STATUS, __EventHandler);
		},

		Deinit: function () {
			console.log('VZThirdParty.Deinit');
			if (__VZThirdParty) __VZThirdParty.removeEventListener(__VZThirdParty.RETURN_STATUS);
		},

		TuneToChannel: function (chNum, callback) {
			if (typeof chNum != 'number')
				throw new TypeError('VZThirdParty.TuneToChannel chNum param should be number type');

			if (!callback)
				console.warn(
					'VZThirdParty.TuneToChannel No Callback API passed. Response may not be received',
				);

			console.log('VZThirdParty.TuneToChannel Channel Number: ' + chNum);
			var json_input = { cmd: EventId.CHANNEL_TUNE, channelnumber: chNum };
			__ExecuteCommandAsync(json_input, callback);
		},

		Record: function (chNum, startTime, callback) {
			if (typeof chNum != 'number')
				throw new TypeError('VZThirdParty.Record chNum param should be number type');
			else if (typeof startTime != 'number')
				throw new TypeError('VZThirdParty.Record startTime param should be number type');

			if (!callback)
				console.warn(
					'VZThirdParty.Record No Callback API passed. Response may not be received',
				);

			console.log('VZThirdParty.Record ChannelNumber: ' + chNum + ' startTime ' + startTime);
			var json_input = {
				cmd: EventId.CHANNEL_RECORD,
				channelnumber: chNum,
				starttime: startTime,
			};
			__ExecuteCommandAsync(json_input, callback);
		},

		SetChannelReminder: function (chNum, startTime, callback) {
			if (typeof chNum != 'number')
				throw new TypeError(
					'VZThirdParty.SetChannelReminder chNum param should be number type',
				);
			else if (typeof startTime != 'number')
				throw new TypeError(
					'VZThirdParty.SetChannelReminder startTime param should be number type',
				);

			if (!callback)
				console.warn(
					'VZThirdParty.SetChannelReminder No Callback API passed. Response may not be received',
				);

			console.log('VZThirdParty.SetChannelReminder ChannelNumber: ' + chNum);
			var json_input = {
				cmd: EventId.CHANNEL_REMINDER,
				channelnumber: chNum,
				starttime: startTime,
			};
			__ExecuteCommandAsync(json_input, callback);
		},

		LaunchOnDemand: function (callback) {
			if (!callback)
				console.warn(
					'VZThirdParty.LaunchOnDemand No Callback API passed. Response may not be received',
				);

			console.log('VZThirdParty.LaunchOnDemand');
			var json_input = { cmd: EventId.ONDEMAND_LAUNCH };
			__ExecuteCommandAsync(json_input, callback);
		},

		LaunchOnDemandTLM: function (tlmName, callback) {
			if (typeof tlmName != 'string')
				throw new TypeError(
					'VZThirdParty.LaunchOnDemandTLM tlmName param should be string type',
				);

			if (!callback)
				console.warn(
					'VZThirdParty.LaunchOnDemandTLM No Callback API passed. Response may not be received',
				);

			console.log('VZThirdParty.LaunchOnDemandTLM TLMName: ' + tlmName);
			var json_input = { cmd: EventId.ONDEMAND_TLM, tlmname: tlmName };
			__ExecuteCommandAsync(json_input, callback);
		},

		LaunchOnDemandRail: function (tlmName, railName, callback) {
			if (typeof tlmName != 'string')
				throw new TypeError(
					'VZThirdParty.LaunchOnDemandRail tlmName param should be string type',
				);
			else if (typeof railName != 'string')
				throw new TypeError(
					'VZThirdParty.LaunchOnDemandRail railName param should be string type',
				);

			if (!callback)
				console.warn(
					'VZThirdParty.LaunchOnDemandRail No Callback API passed. Response may not be received',
				);

			console.log(
				'VZThirdParty.LaunchOnDemandRail TLMName: ' + tlmName + ' RailName: ' + railName,
			);
			var json_input = { cmd: EventId.ONDEMAND_RAIL, tlmname: tlmName, railname: railName };
			__ExecuteCommandAsync(json_input, callback);
		},

		LaunchOnDemandContent: function (tlmName, railName, contentName, callback) {
			if (typeof tlmName != 'string')
				throw new TypeError(
					'VZThirdParty.LaunchOnDemandContent tlmName param should be string type',
				);
			else if (typeof railName != 'string')
				throw new TypeError(
					'VZThirdParty.LaunchOnDemandContent railName param should be string type',
				);
			else if (typeof contentName != 'string')
				throw new TypeError(
					'VZThirdParty.LaunchOnDemandContent contentName param should be string type',
				);

			if (!callback)
				console.warn(
					'VZThirdParty.LaunchOnDemandContent No Callback API passed. Response may not be received',
				);

			console.log(
				'VZThirdParty.LaunchOnDemandContent TLMName: ' +
					tlmName +
					' RailName: ' +
					railName +
					'ContentName: ' +
					contentName,
			);
			var json_input = {
				cmd: EventId.ONDEMAND_CONTENT,
				tlmname: tlmName,
				railname: railName,
				contentname: contentName,
			};
			__ExecuteCommandAsync(json_input, callback);
		},

		LaunchProgramInfo: function (assetId, callback) {
			if (typeof assetId != 'string')
				throw new TypeError(
					'VZThirdParty.LaunchProgramInfo assetId param should be string type',
				);

			if (!callback)
				console.warn(
					'VZThirdParty.LaunchProgramInfo No Callback API passed. Response may not be received',
				);

			console.log('VZThirdParty.LaunchProgramInfo Asset ID: ' + assetId);
			var json_input = { cmd: EventId.ONDEMAND_PI, assetid: assetId };
			__ExecuteCommandAsync(json_input, callback);
		},

		LaunchLiveTVProgramInfo: function (inputData, callback) {
			if (typeof inputData != 'string')
				throw new TypeError(
					'VZThirdParty.LaunchLiveTVProgramInfo inputData param should be string type',
				);

			if (!callback)
				console.warn(
					'VZThirdParty.LaunchLiveTVProgramInfo No Callback API passed. Response may not be received',
				);

			console.log('VZThirdParty.LaunchLiveTVProgramInfo inputData: ' + inputData);
			var json_input = { cmd: EventId.LIVETV_PI, inputData: inputData };
			__ExecuteCommandAsync(json_input, callback);
		},

		LaunchVODProgramInfo: function (inputData, callback) {
			if (typeof inputData != 'string')
				throw new TypeError(
					'VZThirdParty.LaunchVODProgramInfo inputData param should be string type',
				);

			if (!callback)
				console.warn(
					'VZThirdParty.LaunchVODProgramInfo No Callback API passed. Response may not be received',
				);

			console.log('VZThirdParty.LaunchVODProgramInfo inputData: ' + inputData);
			var json_input = { cmd: EventId.VOD_PI, inputData: inputData };
			__ExecuteCommandAsync(json_input, callback);
		},

		LaunchDVRProgramInfo: function (inputData, callback) {
			if (typeof inputData != 'string')
				throw new TypeError(
					'VZThirdParty.LaunchDVRProgramInfo inputData param should be string type',
				);

			if (!callback)
				console.warn(
					'VZThirdParty.LaunchDVRProgramInfo No Callback API passed. Response may not be received',
				);

			console.log('VZThirdParty.LaunchDVRProgramInfo inputData: ' + inputData);
			var json_input = { cmd: EventId.DVR_PI, inputData: inputData };
			__ExecuteCommandAsync(json_input, callback);
		},

		LaunchApplication: function (moduleID, callback) {
			if (typeof moduleID != 'string')
				throw new TypeError(
					'VZThirdParty.LaunchApplication moduleID param should be string type',
				);

			if (!callback)
				console.warn(
					'VZThirdParty.LaunchApplication No Callback API passed. Response may not be received',
				);

			console.log('VZThirdParty.LaunchApplication Module ID: ' + moduleID);
			var json_input = { cmd: EventId.APPS_LAUNCH, moduleid: moduleID };
			__ExecuteCommandAsync(json_input, callback);
		},

		PerformAction: function (actionType, actionData, callback) {
			if (typeof actionType != 'string')
				throw new TypeError(
					'VZThirdParty.PerformAction actionType param should be string type',
				);

			if (!callback)
				console.warn(
					'VZThirdParty.PerformAction No Callback API passed. Response may not be received',
				);

			var json_input = {
				cmd: EventId.PERFORM_ACTION,
				actionType: actionType,
				actionData: actionData,
			};
			__ExecuteCommandAsync(json_input, callback);
		},

		GetData: function (requestInfo, requestData, callback) {
			if (typeof requestInfo != 'string')
				throw new TypeError('VZThirdParty.GetData requestInfo param should be string type');

			if (!callback)
				console.warn(
					'VZThirdParty.GetData No Callback API passed. Response may not be received',
				);

			var json_input = {
				cmd: EventId.REQUEST_INFO,
				requestinfo: requestInfo,
				requestdata: requestData,
			};
			__ExecuteCommandAsync(json_input, callback);
		},
	};
})();

export default VZThirdParty;
